import React, {useContext, useEffect} from 'react';
import {injectIntl} from "react-intl";

import {useFormikContext} from "formik";

import Grid from "@mui/material/Grid";

import CustomCheckbox from "components/checkbox/CustomCheckbox";
import CustomSwitch from "components/switch/CustomSwitch";

import SenderNameField from "./SenderNameField";
import ContactMailAddress from "./ContactMailAddress";
import ContactPhoneNumberField from "./ContactPhoneNumberField";
import SenderAddressField from "./SenderAddressField";
import ApiFields from "./ApiFields";

import {ShippingMethodFormContext} from "../../context/ShippingMethodFormContext";

import {ShippingMethodsWaybillRequired} from "utils/ShippingMethods";

function WaybillFields(props) {
    const {
        isApi,
        setIsApi,
        isWaybill,
        setIsWaybill
    } = useContext(ShippingMethodFormContext);

    const {validateField, values} = useFormikContext()

    const [isWaybillRequired, setIsWaybillRequired] = React.useState(false);

    // trigger validation of waybill fields
    useEffect(() => {
        validateField('senderName');
        validateField('contactMailAddress');
        validateField('contactPhoneNumber');
        validateField('senderAddress');
    }, [isWaybill]);

    useEffect(() => {
        if (!values.discr) {
            return;
        }

        const waybillRequired = ShippingMethodsWaybillRequired.includes(values.discr);

        setIsWaybill(waybillRequired);
        setIsWaybillRequired(waybillRequired)
        setIsApi(waybillRequired)

    }, [values.discr]);

    if (!isWaybillRequired) {
        return null;
    }

    return (
        <Grid item container rowSpacing={3}>
            <Grid item>
                <CustomCheckbox
                    noPadding
                    disabled={isWaybillRequired}
                    checked={isWaybill || isWaybillRequired}
                    label={props.intl.formatMessage({id: 'shippingMethods.form.waybill.label'})}
                    onChange={(event) => {
                        const newValue = event.target.checked;

                        setIsWaybill(newValue);

                        if (newValue === false) {
                            setIsApi(false);
                        }
                    }}
                />
            </Grid>
            {isWaybill && (
                <Grid item>
                    <Grid container rowSpacing={3}>
                        <Grid item xs={12}>
                            <SenderNameField />
                        </Grid>
                        <Grid item container columnSpacing={2}>
                            <Grid item xs={6}>
                                <ContactMailAddress />
                            </Grid>
                            <Grid item xs={6}>
                                <ContactPhoneNumberField />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <SenderAddressField />
                        </Grid>
                        <Grid item>
                            <CustomSwitch
                                disabled={isWaybillRequired}
                                checked={isApi || isWaybillRequired}
                                onClick={() => setIsApi(!isApi)}
                                label={props.intl.formatMessage({id: 'shippingMethods.form.api.label'})}
                            />
                        </Grid>
                        <ApiFields />
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}

export default injectIntl(WaybillFields);
